import React, { useEffect, useState } from 'react'
import './styles/home.css';

const IntroCarousel = () => {



    const [currentSlide, setCurrentSlide] = useState(0);

    const [activeSlideIcons, setActiveSlideIcons] = useState(Array(4).fill(false));


    const nextSlide = () => {
        const nextIndex = (currentSlide + 1) % 4;
        setCurrentSlide(nextIndex);
        updateActiveSlideIcons(nextIndex);
    };

    const prevSlide = () => {
        const prevIndex = currentSlide === 0 ? 4 - 1 : currentSlide - 1;
        setCurrentSlide(prevIndex);
        updateActiveSlideIcons(prevIndex);
    };

    const updateActiveSlideIcons = (activeIndex) => {
        const updatedIcons = activeSlideIcons.map((_, index) => index === activeIndex);
        setActiveSlideIcons(updatedIcons);
    };

    const handleIconClick = (index) => {
        setCurrentSlide(index);
    }

    useEffect(() => {
        const timer = setInterval(() => {
            nextSlide();
        }, 7000);

        return () => clearInterval(timer);
    });


    return (
        <div className='intro-carousel'>
            <div className='carousel-img-container'>
                <div className={`carousel-img-child ${currentSlide === 0 ? 'img-child-active' : ''}`} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/slide-1.jpg)` }}>
                    <div className='intro-carousel-body'>
                        <h1 className='gold-text-gradient' id='between-choirs' style={{ color: '#cbaa59' }}>BETWEEN CHOIRS</h1>
                        <p className='slide-description sd-1'>Your Edutainment for Today's Show Choir Contest</p>
                    </div>
                </div>

                <div className={`carousel-img-child ${currentSlide === 1 ? 'img-child-active' : ''}`} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/o-slide-2.jpg)` }}>
                    <div className='intro-carousel-body'>
                        <h1>PUT THE POPCORN DOWN</h1>
                        <p className='slide-description'>Explore Show Choir Contest Etiquette, Famous Alumni, Rich History, After-Contest Partying with Recipes, and So Much More!</p>
                    </div>
                </div>

                <div className={`carousel-img-child ${currentSlide === 2 ? 'img-child-active' : ''}`} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/slide-4.jpg)` }}>
                    <div className='intro-carousel-body'>
                        <h1>DON'T MISS A BEAT</h1>
                        <p className='slide-description'>Got Downtime Between Performances or While Judges Score? Explore Fun Games, Activities, Articles, and Stories—Discover New Dimensions in the World of Show Choir!</p>
                    </div>
                </div>

                <div className={`carousel-img-child ${currentSlide === 3 ? 'img-child-active' : ''}`} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/slide-3.jpg)` }}>
                    <div className='intro-carousel-body'>
                        <h1>STRIKE THE RIGHT NOTE</h1>
                        <p className='slide-description'>From Today’s Stage to Scholarships, Music Degrees, and Broadway Stardom—Discover It All!</p>
                    </div>
                </div>




            </div>



            <div className='control-panel-intro-carousel'>
                <div onClick={prevSlide} className='prev-btn-intro-cr carousel-btn btn-background-circle'>
                    <svg className='arrow-prev-intro arrow-intro' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.53 162.9">
                        <path
                            className='prev-intro svg-btn-intro'
                            d="M217.4,165.87a7.76,7.76,0,0,0,0,12.12l52,41.61,38.68,30.94a12.87,12.87,0,0,0,20.91-10h0a12.88,12.88,0,0,0-4.83-10.05L310.62,219.6,251,171.93l59.6-47.65,13.57-10.85A12.89,12.89,0,0,0,329,103.38h0a12.87,12.87,0,0,0-20.91-10l-38.68,31Z"
                            transform="translate(-214.49 -90.49)"
                        />
                    </svg>
                </div>
                <div className='active-slide-icons'>
                    <div
                        className={`slide-icon ${currentSlide === 0 ? 'active-sld-icon' : ''}`}
                        onClick={() => setCurrentSlide(0)}
                    />
                    <div
                        className={`slide-icon ${currentSlide === 1 ? 'active-sld-icon' : ''}`}
                        onClick={() => setCurrentSlide(1)}
                    />
                    <div
                        className={`slide-icon ${currentSlide === 2 ? 'active-sld-icon' : ''}`}
                        onClick={() => setCurrentSlide(2)}
                    />
                    <div
                        className={`slide-icon ${currentSlide === 3 ? 'active-sld-icon' : ''}`}
                        onClick={() => setCurrentSlide(3)}
                    />
                </div>
                <div onClick={nextSlide} className='next-btn-intro-cr carousel-btn btn-background-circle'>
                    <svg className='arrow-next-intro arrow-intro' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.53 162.9">
                        <path
                            className='next-intro svg-btn-intro'
                            d="M326.1,165.87a7.75,7.75,0,0,1,0,12.12l-52,41.61-38.69,30.94a12.86,12.86,0,0,1-20.9-10h0a12.88,12.88,0,0,1,4.83-10.05l13.57-10.85,59.6-47.67-59.6-47.65-13.57-10.85a12.89,12.89,0,0,1-4.83-10.05h0a12.86,12.86,0,0,1,20.9-10l38.69,31Z"
                            transform="translate(-214.49 -90.49)"
                        />
                    </svg>
                </div>
            </div>
        </div>
    )
}


export default IntroCarousel
